import { render, staticRenderFns } from "./Hoverbox.vue?vue&type=template&id=6ba31f42&scoped=true&"
import script from "./Hoverbox.vue?vue&type=script&lang=ts&"
export * from "./Hoverbox.vue?vue&type=script&lang=ts&"
import style0 from "./Hoverbox.vue?vue&type=style&index=0&id=6ba31f42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba31f42",
  null
  
)

export default component.exports